"use client";

import { X } from "lucide-react";
import { Button, Tooltip, TooltipContent, TooltipTrigger } from "@wtc/ui";
import type { ClientFolder } from "./SaveAttachmentsToGoogleDriveModal.types";

interface SelectedClientFolderProps {
  onClear: () => void;
  selectedClient: ClientFolder | null;
}

export function SelectedClientFolder({ onClear, selectedClient }: SelectedClientFolderProps) {
  if (!selectedClient) {
    return null;
  }

  return (
    <div className="p-3 bg-blue-50 dark:bg-blue-950/40 border border-blue-200 dark:border-blue-800 rounded-lg flex items-center justify-between">
      <div>
        <p className="text-sm font-medium text-blue-900 dark:text-blue-200">Selected: {selectedClient.name}</p>
      </div>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="icon"
            aria-label="Clear selected client folder"
            onClick={onClear}
            className="text-blue-600 hover:text-blue-800"
          >
            <X className="h-4 w-4" />
          </Button>
        </TooltipTrigger>
        <TooltipContent>Clear selected client folder</TooltipContent>
      </Tooltip>
    </div>
  );
}
